import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import { useCallback, useState } from "react";
import Menu from "@mui/material/Menu";
import { useStyles } from "./styles";
import { map } from "lodash";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";

type IconButtonMenuProps = IconButtonProps & {
  options: { icon?: string; label: string; onClick?: () => void }[];
};

export function IconButtonMenu({ options, ...rest }: IconButtonMenuProps) {
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickOption = useCallback((_: any) => {
    _?.onClick();
    handleClose();
  }, []);
  return (
    <>
      <IconButton
        {...rest}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {rest.children}
      </IconButton>
      <Menu
        keepMounted
        classes={{ root: styles.root, paper: styles.paper }}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        elevation={0}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {map(options, (option, index) => (
          <MenuItem
            onClick={() => {
              handleClickOption(option);
            }}
            style={{ padding: 12 }}
            key={index.toString()}
          >
            <Avatar
              id="avatar"
              className={styles.icon}
              src={option.icon}
              sx={{ width: 24, height: 24 }}
              variant="rounded"
            />
            <ListItemText
              primary={option.label}
              classes={{ primary: styles.font }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
